import { colors } from '@fitpet/constants-global'
import { clsx } from 'clsx'
import { useCountWishlist, useGetProductsByAdSlugV2 } from '@/apis/rest/generated/hooks'
import { SearchDisplayProductInfoSortByEnum, SortDirectionEnum } from '@/apis/rest/generated/types'
import { StyledDivider } from '@/components/common/divider'
import { HorizontalScrollContainer } from '@/components/domains/etc/horizontal-scroll-container'
import { NewProductCard } from '@/components/domains/products/new-product-card/new-product-card'
import { PRODUCT_CARD_SIZES } from '@/components/domains/products/new-product-card/new-product-card.type'
import { PAGE_LIMIT } from '@/constants/pages.const'
import { useGetCartData } from '@/containers/hooks/cart/useGetCartData'
import { transformProductTypeDefinedByFrontend } from '@/utils/product/product-card.util'
import styles from './cart-event-product-widget-v2.module.css'

const BUTTON_POSITION_Y = 30
const RENDER_BUTTON_COUNT = 3

interface CartEventProductWidgetProps {
  widgetTitle: string
  eventId: string
  isLastSection: boolean
}

export const CartEventProductWidgetV2 = ({ widgetTitle, eventId, isLastSection }: CartEventProductWidgetProps) => {
  const { getCartDataByChecked, updateCartDataParamsWithNewIds } = useGetCartData()

  // 사용자가 찜한 상품 전체 개수
  const { refetch: refetchWishCount } = useCountWishlist({
    query: {
      enabled: false,
    },
  })

  const { data } = useGetProductsByAdSlugV2(eventId, {
    sortBy: SearchDisplayProductInfoSortByEnum.RANDOM,
    sortDirection: SortDirectionEnum.DESC,
    size: PAGE_LIMIT.WIDGET,
    includeSoldOut: false,
  })

  const handleClickLike = () => {
    refetchWishCount()
  }

  if (data?.page?.totalCount === 0) return null

  return (
    <>
      <div className={styles.cartEventProductListWrapper}>
        <div className={clsx(styles.cartEventProductListHeader, 'font-heading6-bold gray-900')}>{widgetTitle}</div>
        <HorizontalScrollContainer
          hideRightButton={(data?.page?.totalCount || 0) < RENDER_BUTTON_COUNT}
          buttonPositionY={BUTTON_POSITION_Y}
        >
          <div className={styles.cartEventProductListList}>
            {data?.data?.map(({ product, displayProductInfoId }) => {
              if (!product) {
                return null
              }

              return (
                <div key={displayProductInfoId}>
                  <NewProductCard
                    product={transformProductTypeDefinedByFrontend(product)}
                    size={PRODUCT_CARD_SIZES.lg}
                    hasCartButton
                    callbackAddToCart={(ids) => {
                      if (ids) {
                        getCartDataByChecked({
                          param: updateCartDataParamsWithNewIds(ids),
                          enabledUpdateCartCount: false,
                        })
                      }
                    }}
                    callbackLike={handleClickLike}
                  />
                </div>
              )
            })}
          </div>
        </HorizontalScrollContainer>
      </div>
      {!isLastSection && !!data?.data?.length && (
        <StyledDivider height="0.1rem" margin="2.4rem 0 0 0" backgroundColor={colors.GRAY_70} />
      )}
    </>
  )
}
